



















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation, State } from 'vuex-class';
@Component
export default class TraceTable extends Vue {
  @State('rocketTrace') private rocketTrace: any;
  @State('rocketbot') private rocketbot: any;
  @Mutation('rocketTrace/SET_TRACE_FORM_ITEM') private SET_TRACE_FORM_ITEM: any;
  @Mutation('rocketTrace/SET_CURRENT_TRACE') private SET_CURRENT_TRACE: any;
  @Mutation('rocketTrace/SET_DEFAULT_EMPTY_TRACE') private SET_DEFAULT_EMPTY_TRACE: any;
  @Action('rocketTrace/GET_TRACELIST') private GET_TRACELIST: any;
  @Action('rocketTrace/GET_TRACE_SPANS') private GET_TRACE_SPANS: any;
  private loading: boolean = false;
  private selectedKey: string = '';
  @Watch('rocketTrace.traceList')
  private onTraceListChange() {
    if (this.rocketTrace.traceList && this.rocketTrace.traceList.length > 0) {
      this.selectTrace(this.rocketTrace.traceList[0]);
    }
    if (this.rocketTrace.traceList && this.rocketTrace.traceList.length === 0) {
      this.SET_DEFAULT_EMPTY_TRACE();
    }
  }
  private selectTrace(i: any) {
    this.SET_CURRENT_TRACE(i);
    this.selectedKey = i.key;
    this.$eventBus.$emit('TRACE-TABLE-LOADING');
    this.$eventBus.$emit('TRACE-LIST-LOADING');
    if (i.traceIds.length) {
      this.GET_TRACE_SPANS({traceId: i.traceIds[0]});
    }
  }
  private changeSort(e: any) {
    this.SET_TRACE_FORM_ITEM({type: 'queryOrder', data: e.target.options[e.target.selectedIndex].value});
    this.SET_TRACE_FORM_ITEM({type: 'paging', data: { pageNum: 1, pageSize: 15, needTotal: true}});
    this.GET_TRACELIST();
  }
  private page(p: number) {
    this.loading = true;
    this.SET_TRACE_FORM_ITEM({type: 'paging', data: { pageNum: p, pageSize: 15, needTotal: true}});
    this.GET_TRACELIST().then(() => {
      this.loading = false;
    });
  }
  private created() {
    this.$eventBus.$on('SET_LOADING_TRUE', this, (cb: any) => {
      this.loading = true;
      if (cb) {
        cb();
      }
    });
    this.$eventBus.$on('SET_LOADING_FALSE', this, () => {
      this.loading = false;
    });
  }
}
